<template>
  <el-dialog
    :visible="visible"
    width="900px"
    :show-close="true"
    class="egl-dialog-elm channel-dialog"
    :title="$locale('sideMenu.settings.devices') + actionText"
    @close="close_fn"
    :close-on-click-modal="false"
  >
    <el-form ref="form" :model="form" :disabled="!isEdit" :rules="formRules" label-position="top">
      <el-form-item :label="$locale('global.name')" class="name-input" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item :label="$locale('setting.device.devicetype')" class="device-type" prop="deviceType">
        <el-input v-model="form.deviceType" readonly></el-input>
      </el-form-item>
      <el-form-item label="デバイスSN" class="device-type" prop="deviceSecret">
        <el-input v-model="form.hardwareId" readonly></el-input>
      </el-form-item>
      <el-form-item label="HardwareId" class="name-input" prop="hardwareId">
        <el-input v-model="form.hardwareId" clearable></el-input>
      </el-form-item>
      <el-form-item :label="$locale('setting.device.devicecoop')" class="device-unbund">
        <el-input v-model="oneTimePasswordText" readonly></el-input>
        <el-button
          class="egl-btn-red"
          v-if="form.status == 'active'"
          @click="unBound_fn"
        >{{ $locale('setting.device.button.reset') }}</el-button>
        <el-button class="egl-btn-red" @click="refreshPWD_fn"
        >{{  $locale('setting.device.button.refresh') }}</el-button>
      </el-form-item>

      <el-form-item :label="$locale('setting.device.pay.methods')">
            <div class="dynamic-table">
              <div class="table-box">
                <el-table :data="displayPayArr" class="egl-table" border>
                  <el-table-column :label="$locale('setting.device.shownas')" width="70" align="center">
                    <template slot-scope="scope">
                        <el-checkbox v-model="scope.row.display"  ></el-checkbox>
                    </template>
                  </el-table-column>

                  <el-table-column :label="$locale('setting.device.paymntmethod')" prop="name"><!--決済方法-->
                    <!-- <template>
                      <el-form-item class="w160" v-for="item in paymentTypeList" v-bind:key="item.id">
                        <template>
                          <div class="not-border-input">{{ item.name }}</div>
                        </template>
                      </el-form-item> -->
                      <!-- <p>{{}}</p> -->
                      <!--<el-select v-model="scope.row.paymentId">
                        <el-option
                          v-for="item in paymentTypeList"
                          :label="item.name"
                          :value="item.id"
                          :key="item.id"
                        ></el-option>
                      </el-select>
                    </template> -->
                  </el-table-column>

                  <el-table-column :label="$locale('setting.device.paymntName')" prop="nameShow">
                    <!-- <template>
                      <el-form-item class="w160" v-for="item in paymentTypeList" v-bind:key="item.id">
                        <template v-if="scope.row.paymentId === item.id">
                          <div class="not-border-input">{{ item.nameShow }}</div>
                        </template>
                      </el-form-item> -->
                      <!--<el-select v-model="scope.row.paymentId">
                        <el-option
                                v-for="item in paymentTypeList"
                                :label="item.nameShow"
                                :value="item.id"
                                :key="item.id"
                                :disabled=true
                        ></el-option>
                      </el-select>
                    </template> -->

                  </el-table-column>
                  <!--<el-table-column :label="$locale('setting.device.followaction')">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.payTypeId">
                        <el-option
                          v-for="item in payTypeList"
                          :label="item.name"
                          :value="item.id"
                          :key="item.id"
                        ></el-option>
                      </el-select>
                    </template>
                  </el-table-column>-->
                </el-table>
              </div>
            </div>
        <template v-if="form.deviceType == 'SELFCASHIER'">
          <h3 class="info-title">{{ $locale('setting.device.cc380')}}</h3>
          <el-form-item :label="$locale('setting.device.dialog.ipAddress')">
            <el-input v-model="form.device380.ipAddress" class="make80percent" :placeholder="$locale('setting.device.dialog.ipAddress.p')"/>
          </el-form-item>
          <el-form-item :label="$locale('setting.device.dialog.device380')">
            <el-input v-model="form.device380.deviceId" class="make80percent" :placeholder="$locale('setting.device.dialog.device380.p')"/>
          </el-form-item>
          <h3 class="info-title">{{ $locale('setting.device.cc3000')}}</h3>
          <el-form-item :label="$locale('setting.device.dialog.ipAddress')">
            <el-input v-model="form.device3000.ipAddress" class="make80percent" :placeholder="$locale('setting.device.dialog.ipAddress.p')"/>
          </el-form-item>
          <el-form-item :label="$locale('setting.device.dialog.port')">
            <el-input v-model="form.device3000.port" class="make80percent" :placeholder="$locale('setting.device.dialog.port.p')"/>
          </el-form-item>
          <el-form-item :label="$locale('setting.device.dialog.serverport')">
            <el-input v-model="form.device3000.vega3000ServerPort" class="make80percent" :placeholder="$locale('setting.device.dialog.port.p')"/>
          </el-form-item>
        </template>
      </el-form-item>

      <el-form-item :label="$locale('setting.device.numOfReceiptsPrinted')" prop="printQtyCon" class="name-input" v-if="showPrintQtyCon">
        <el-input
          v-model.number="form.printQtyCon"
          maxlength="5"
        ></el-input>
      </el-form-item>

      <el-form-item :label="$locale('setting.device.numOfTicketPrinted')" prop="printQtyTicket" class="name-input" v-if="showPrintQtyCon">
        <el-input
          v-model.number="form.printQtyTicket"
          maxlength="5"
        ></el-input>
      </el-form-item>      
      <ApproveField v-if="!form.isApprove" v-model="form.reflectDate" :formData="form" fieldName="reflectDate" />
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-button class="egl-btn-white" @click="close_fn">{{$locale("global.cancel")}}</el-button>
          <el-button class="egl-btn-yellow" @click="save_fn">{{$locale("global.confirm")}}</el-button>
        </el-col>
      </el-row>
    </div>
  </el-dialog>

</template>
<style scoped>
.info-title {
  font-weight: 200;
  font-size: 1.2rem;
}
.make80percent {
  max-width:80%;
}
</style>
<script>
import { unBound, refreshPWD } from "@/helpers/service/api/device.js";
import RuleTest from "@/utils/simpleRule.js";
import ApproveField from "@/components/common/ApproveField";

export default {
  name: "DeviceDialog",
  data() {
    return {
      testBool : false,
      visible: false,
      actionText: this.$locale("global.edit"),
      form: {
        name: "",
        deviceType: "",
        oneTimePassword: "",
        paymentTypes: [],
        reflectDate: this.$moment().startOf("day").valueOf(),
        device380: {
          ipAddress: "",
          deviceId: "",
        },
        device3000: {
          ipAddress: "",
          port:"",
          vega3000ServerPort: "",
        },
      },
      oneTimePasswordText: "",
      rule: {
        name: {
          required: this.$locale("form.plsEnterYourName")
        }
      },
      formRules: {
        name: [ {
          required: true,
          message: this.$locale("form.plsEnterYourName"),
          trigger: "blur",
        } ],
        printQtyCon: [ {
          type: "number",
          message: this.$locale("form.mustFillInNum"),
          trigger: "blur",
        } ],
        printQtyTicket: [ {
          type: "number",
          message: this.$locale("form.mustFillInNum"),
          trigger: "blur",
        } ],
      },
      displayPayArr: [],
    };
  },
  computed: {
    showPrintQtyCon() {
      const _showList = ["SELFCASHIER", "POS"];
      return _showList.includes(this.form.deviceType);
    }
  },
  methods: {
    close_fn() {
      this.displayPayArr = [];
      this.$refs.form.resetFields();
      this.$emit("closeFn");
    },
    save_fn() {
      let obj = RuleTest(this.rule, this.form);
      let data = {};

      // if (!obj.success) {
      //   this.$alert(obj.message, {
      //     showClose: false
      //   });

      //   return;
      // }
      // // obj.data.isApprove = true;
      // set form paymentTypes
      let arr = [];
      this.displayPayArr.forEach(item => {
        if (item.display || item.type == 'cash380') {
          if(item.display == false && item.type=='cash380' && this.form.deviceType=='SELFCASHIER') {
            arr.push({
              display: false,
              paymentId: item.id
            });
          } else if(item.display) {
            arr.push({
              display: true,
              paymentId: item.id
            });
          }
        } 
      });
      obj.data.paymentTypes = arr;
      data = { ...obj.data };

      this.$refs.form.validate(valid => {
        if (valid) {
          this.$emit("returnMsg", data);
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName("is-error");
            isError[0].querySelector("input").focus();
          }, 100);

          return false;
        }
      });
    },
    removeTableRow(index) {
      let formObj = { ...this.form };

      formObj.paymentTypes.splice(index, 1);

      this.form = { ...formObj };
    },
    addTableRow() {
      let formObj = { ...this.form };

      formObj.paymentTypes.push({
        display: true,
        payTypeId: "",
        paymentId: "",
        paymentName: ""
      });

      this.form = { ...formObj };
    },
    unBound_fn() {
      unBound({ id: this.form.id })
        .then(res => {
          if (res.success) {
            this.form = { ...this.form, status: "inactive" };
          }
        });
    },
    refreshPWD_fn() {
      refreshPWD({ id: this.form.id })
        .then(res => {
          if (res.success) {
            this.form = { ...this.form, oneTimePassword: res.data };
            this.oneTimePasswordText =
              res.data +
              this.$locale("setting.device.dialog.otp");
          }
        });
    },
    getArr() {
      if (this.detailObj.id && this.paymentTypeList) {
        let arr = [];
        let tmp = this.detailObj.paymentTypes
        this.paymentTypeList.forEach(item => {
          let idx = this.detailObj.paymentTypes.findIndex(e =>  e.paymentId === item.id )
          let obj = this.detailObj.paymentTypes[idx]
          if(idx >= 0) {
            arr.push({
              id: item.id,
              name: item.name,
              nameShow: item.nameShow,
              type: item.type,
              display: obj.display,
            })
          } else {
            arr.push({
              id: item.id,
              name: item.name,
              nameShow: item.nameShow,
              type: item.type,
              display: false,
            })
          }
        })

        // this.paymentTypeList.forEach(paymentType => {
        //   let boolean = false;
        //   this.detailObj.paymentTypes.forEach(item => {
        //     if (paymentType.id === item.paymentId) {
        //       boolean = true;
        //     }
        //   });
        //   arr.push({
        //     display: boolean,
        //     id: paymentType.id,
        //     name: paymentType.name,
        //     nameShow: paymentType.nameShow
        //   });
        // });
        this.displayPayArr = arr;
      }
    }
  },
  mounted() {
  },

  props: {
    actionVisible: {
      type: Boolean,
      default: false
    },
    detailObj: {
      type: Object,
      default: () => {}
    },
    paymentTypeList: {
      type: Array,
      default: () => []
    },
    payTypeList: {
      type: Array,
      default: () => []
    },
    isEdit: {
      type: Boolean,
      default: true,
    }
  },
  watch: {
    displayPayArr() {
      // console.log("watch",this.displayPayArr)
    },
    actionVisible() {
      let formObj = {
        ...this.detailObj,
      };
      let oneTimePasswordText = "";

      if (formObj.paymentTypes.length == 0) {
        formObj.paymentTypes.push({
          display: false,
          payTypeId: "",
          paymentId: "",
          paymentName: ""
        });
      }

      if (formObj.oneTimePassword != "") {
        oneTimePasswordText =
          formObj.oneTimePassword +
          this.$locale("setting.device.dialog.otp");
      }

      this.oneTimePasswordText = oneTimePasswordText;
      this.visible = this.actionVisible;
      this.form = formObj;

      if (this.actionVisible) {
        this.getArr();
      } else {
        this.displayPayArr = [];
      }
    },
  },
  components: {
    ApproveField,
  }
};
</script>
